(function bootWeSlideShow() {
  if (typeof jQuery === 'undefined' || typeof jQuery.fn === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
    return setTimeout(bootWeSlideShow, 50);
  }

  var $ = jQuery;

  if (!window.arrows) {
    window.arrows = {
      icon_next: '<button type="button" class="slick-next" aria-label="Next" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
      icon_prev: '<button type="button" class="slick-prev" aria-label="Previous" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>'
    };
  }

  window.rtl_slick = document.documentElement.getAttribute('dir') === 'rtl';

  function postMessageToPlayer(player, command) {
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), '*');
  }

  function initSlideshow($root) {
    var slickSlideshow = ($root || $(document)).find('[data-init-slideshow]').addBack('[data-init-slideshow]');
    if (!slickSlideshow.length) return;

    slickSlideshow.each(function () {
      var self = $(this);
      var auto_playvideo = self.data('auto-video');

      if (self.find('.item-video').length && !document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        if (firstScriptTag && firstScriptTag.parentNode) {
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        } else {
          document.head.appendChild(tag);
        }
      }

      function playPauseVideo(slick, control) {
        var currentSlide = slick.find('.slick-current .item');
        var player;
        var video;

        if ($(window).width() > 551) {
          player = currentSlide.find('iframe.slide-pc').get(0);
        } else {
          player = currentSlide.find('iframe.slide-mobile').get(0);
        }

        if (currentSlide.hasClass('slide-youtube')) {
          if (control === 'play') {
            postMessageToPlayer(player, { event: 'command', func: 'playVideo' });
            self.slick('slickPause');
          } else {
            postMessageToPlayer(player, { event: 'command', func: 'pauseVideo' });
          }
        } else if (currentSlide.hasClass('slide-video')) {
          video = currentSlide.find('video').get(0);
          if (video != null) {
            if (control === 'play') {
              video.play();
              self.slick('slickPause');
              $(video).on('ended', function () {
                self.slick('slickPlay');
                self.slick('next');
              });
            } else {
              video.pause();
            }
          }
        }
      }

      function changeDotsPosition(slider) {
        setTimeout(function () {
          if (slider.find('.slick-active:has(.placeholder-svg)').length) {
            slider.attr('style', '--height-image-active:' + slider.find('.slick-active .placeholder-svg').height() + 'px');
          } else {
            slider.attr('style', '--height-image-active:' + slider.find('.slick-active .slide-mobile img').height() + 'px');
          }
        }, 500);
      }

      function updateDotsWithImages(slider, plusIcon, time) {
        setTimeout(function () {
          var dots = $('.slick-dots > li > button', slider);
          $.each(dots, function () {
            var dot_img = $('[aria-describedby="' + $(this).parent().attr('id') + '"]').data('dot-img');
            if (dot_img) {
              $(this).html('<img src="' + dot_img + '" alt="" />' + plusIcon);
            } else {
              $(this).html(plusIcon);
            }
          });
        }, time);
      }

      self.off('.weSlideShow');
      self.on('init.weSlideShow', function (slick) {
        slick = $(slick.currentTarget);
        if (auto_playvideo) {
          setTimeout(function () {
            playPauseVideo(slick, 'play');
          }, 1000);
        }

        var slider = $(this);
        if (slider.data('dot-with-image')) {
          var plusIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" width="128" height="128"><g><polygon fill="#1E3C32" points="127,59 69,59 69,1 59,1 59,59 1,59 1,69 59,69 59,127 69,127 69,69 127,69"/></g></svg>';
          updateDotsWithImages(slider, plusIcon, 100);
          window.matchMedia('(min-width: 1024px)').addEventListener('change', function () {
            updateDotsWithImages(slider, plusIcon, 500);
          });
          window.matchMedia('(min-width: 768px)').addEventListener('change', function () {
            updateDotsWithImages(slider, plusIcon, 500);
          });
          if (window.innerWidth < 1025 && slider.find('.slick-active .slide-content.enable_position_outside_image').length) {
            changeDotsPosition(slider);
            $(window).on('resize.weSlideShow', function () {
              changeDotsPosition(slider);
            });
          }
        }
      });

      if (auto_playvideo) {
        self.on('beforeChange.weSlideShow', function (event, slick) {
          slick = $(slick.$slider);
          playPauseVideo(slick, 'pause');
        });
        self.on('afterChange.weSlideShow', function (event, slick) {
          self.find('.item.slick-slide:not(.slick-current) .fluid-width-video-wrapper .video').css('display', 'none');
          self.find('.slick-current .fluid-width-video-wrapper .video').css('display', 'block');
          slick = $(slick.$slider);
          playPauseVideo(slick, 'play');
          changeDotsPosition($(this));
        });
      }

      if (self.not('.slick-initialized').length) {
        var dots = self.data('dots') != 'none';
        var arrowsMobile = false;
        var customPaging;
        if (self.data('dots') == 'number') {
          arrowsMobile = true;
          customPaging = function (slider, i) {
            var index = i + 1;
            var count = slider.slideCount;
            return '<a class="dot" aria-label="' + index + '/' + count + '">' + index + '/' + count + '</a>';
          };
        }
        self.slick({
          dots: dots,
          slidesToScroll: 1,
          verticalSwiping: false,
          fade: self.data('fade'),
          cssEase: 'ease',
          adaptiveHeight: true,
          autoplay: self.data('autoplay'),
          autoplaySpeed: self.data('autoplay-speed'),
          arrows: self.data('arrows'),
          nextArrow: window.arrows.icon_next,
          prevArrow: window.arrows.icon_prev,
          customPaging: customPaging,
          rtl: window.rtl_slick,
          speed: self.data('speed') || 500,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                arrows: arrowsMobile,
                customPaging: customPaging,
                dots: true
              }
            },
            {
              breakpoint: 768,
              settings: {
                arrows: arrowsMobile,
                customPaging: customPaging,
                dots: true
              }
            }
          ]
        });
      }
    });
  }

  initSlideshow($('.we-slide-show'));

  document.addEventListener('shopify:section:load', function (event) {
    var root = $(event.target).find('.we-slide-show').addBack('.we-slide-show');
    if (root.length) initSlideshow(root);
  });
})();
